import { v4 } from 'uuid';

export default ()=>{
  return v4()
}
